<div [id]="controlId">
    <div fxLayout="row" fxLayoutAlign="start end" class="clickBox">
        <forge-label-value attr.telemetry="Submission-{{label}}">
            <span slot="label">{{label}}</span>
            <span slot="value" fxLayout="row">
                <div class="color-square" attr.telemetry="Submission-{{label}}"
                    [ngStyle]="{'background-color': valueModel}" id="{{controlId}}-color-box">
                    <forge-tooltip position="bottom">{{valueModel}}</forge-tooltip>
                </div>
                <forge-button [dense]="compact" [hidden]="isViewOnly" variant="outlined"
                    class="popup-target tt-margin--left" attr.telemetry="Submission-{{label}}" [disabled]="isViewOnly"
                    id="{{controlId}}-btn">
                    Select color
                </forge-button>
                <forge-popover anchor="{{controlId}}-btn" (forge-popover-toggle)="focusOut($event)">
                    <div #popupContent id="{{controlId}}-popup" class="popup-container">
                        <div class="popup-card">
                            <forge-color-picker [value]="valueModel" focusOnLoad
                                (forge-color-picker-change)="valueChanged($event.detail)"
                                [propertyMetadata]="propertyMetadata" allowOpacity="false">
                            </forge-color-picker>
                        </div>
                    </div>
                </forge-popover>
            </span>
            <span slot="helper-text" [hidden]="!hint">{{hint}}</span>
            <span slot="helper-text">{{error}}</span>
        </forge-label-value>
    </div>
</div>